var map = {
	"./": "025f",
	"./cases": "6053",
	"./cases.js": "6053",
	"./common": "0df5",
	"./common.js": "0df5",
	"./contact": "56c2",
	"./contact.js": "56c2",
	"./index": "025f",
	"./index.js": "025f",
	"./solutions": "43a9",
	"./solutions.js": "43a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "374c";